import en from "date-fns/locale/en-US";
import ko from "date-fns/locale/ko";
import { useEffect, useState } from "react";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useTranslation } from "react-i18next";
import "react-toastify/dist/ReactToastify.css";
import {
  Card,
  Col,
  Modal,
  ModalBody,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap";
import AccountInfoTab from "./Tabs/AccountInfoTab";
import StoreInfoTab from "./Tabs/StoreInfoTab";
import BusinessInfoTab from "./Tabs/BusinessInfoTab";
import userApi from "api/userApi";

export interface Props {
  isOpen: boolean;
  item?: any;
  triggerRefresh?: () => void;
  onClose?: () => void;
  setLinkImage?: any
}

registerLocale("en", en);
registerLocale("ko", ko);

const RecruiterDetail = ({ isOpen, item, triggerRefresh, onClose, setLinkImage }: Props) => {
  const { t, i18n } = useTranslation();
  const [activeTab, setActiveTab] = useState("ACCOUNT_INFO");
  const [dataProfile, setDataProfile] = useState<any>(null);
  
  const tabChange = (tab: any) => {
    if (activeTab !== tab) {
      setActiveTab((_prev) => tab);
    }
  };

  const onCloseClick = () => {
    setActiveTab('ACCOUNT_INFO');
    onClose && onClose();
  };

  const handleUpdateSuccess = async (type?: string) => {
    if(!item?.id) return;

    try {
      const response: any = await userApi.getUser(item?.id);
      if(response?.data) {
        // console.log(response?.data, "handle")
        setDataProfile(response?.data)
      }
    }catch(error) {
      console.log(error)
    }
    
    if(type !== "noRefresh") {
      triggerRefresh && triggerRefresh();
    }
  }

  const isGuest = () => {
    if(dataProfile?.user_device?.login_type === 'GUEST') return true;

    return false;
  }

  useEffect(() => {
    if(item) {
      handleUpdateSuccess("noRefresh")
      // setDataProfile(item)
    }
  }, [item])

  return (
    <Modal isOpen={isOpen} centered={true} size="xl" scrollable={true}>
      <ModalHeader toggle={onCloseClick}>{`${t("Detail User")} ${item?.email ? '-'  : ""} ${item?.email || ""}` }</ModalHeader>
      <ModalBody className="pt-0">
        <div style={{ minHeight: "calc(100dvh - 200px)" }}>
          <Col lg={12}>
            <Card
              id="ACCOUNT_INFO"
              style={{ boxShadow: "0px 3px 4px 0px rgba(0, 0, 0, 0.03)", borderTop: "unset" }}
            >
              <div
                style={{
                  background: "#f3f6f9",
                  borderTopLeftRadius: "0.6rem",
                  borderTopRightRadius: "0.6rem",
                  position: "sticky",
                  top: "0px",
                  zIndex: 99,
                  borderTop: "1px solid #e9ebec"
                }}
              >
                <div
                  className="d-block"
                  style={{
                    background: "#f3f6f9",
                    borderRadius: "0.6rem",
                    width: "fit-content",
                  }}
                >
                  <Nav
                    tabs
                    className="nav nav-tabs nav-link-none-hover nav-justified"
                  >
                    <NavItem style={{ minWidth: "120px" }}>
                      <NavLink
                        style={{
                          cursor: "pointer",
                          background: `${
                            activeTab === "ACCOUNT_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "ACCOUNT_INFO" ? "white" : "unset"
                          }`,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => tabChange("ACCOUNT_INFO")}
                      >
                        {t("Account Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "100px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "STORE_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "STORE_INFO" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("STORE_INFO")
                        }}
                      >
                        {t("Store Info")}
                      </NavLink>
                    </NavItem>
                    <NavItem style={{ minWidth: "140px" }}>
                      <NavLink
                        style={{
                          cursor: `${
                            isGuest() ? "default" : "pointer"
                          }`,
                          background: `${
                            activeTab === "BUSINESS_INFO"
                              ? "var(--vz-primary)"
                              : "unset"
                          }`,
                          color: `${
                            activeTab === "BUSINESS_INFO" ? "white" : (isGuest() ? "gray" : "unset")
                          }`,
                          borderTopLeftRadius: 0,
                          borderTopRightRadius: 0,
                        }}
                        onClick={() => {
                          if(isGuest()) return;

                          tabChange("BUSINESS_INFO")
                        }}
                      >
                        {t("Business Info")}
                      </NavLink>
                    </NavItem>
                  </Nav>
                </div>
              </div>
              <TabContent activeTab={activeTab}>
                <TabPane tabId="ACCOUNT_INFO">
                  {activeTab === "ACCOUNT_INFO" && (
                    <AccountInfoTab data={dataProfile} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="STORE_INFO">
                  {activeTab === "STORE_INFO" && (
                    <StoreInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
                <TabPane tabId="BUSINESS_INFO">
                  {activeTab === "BUSINESS_INFO" && (
                    <BusinessInfoTab data={dataProfile} handleUpdateSuccess={handleUpdateSuccess} setLinkImage={setLinkImage} />
                  )}
                </TabPane>
              </TabContent>
            </Card>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default RecruiterDetail;
